import { ReportsAnalytics } from './analytics/report-dashboards-analytics.service';
import { ReportComponentsVisualizationsFacade } from './facades/components-visualizations.facade';
import {
  AppliedFiltersBreadcrumbsService,
  DateBreadcrumbsService,
  DatePointsBreadcrumbsService,
  DetailsFunnelBreadcrumbsService,
  DetailsGenericBreadcrumbsService,
  DetailsTrendBreadcrumbsService,
  ReportsBreadcrumbsService,
  ReportsComponentDetailsBreadcrumbsService,
} from './services/breadcrumbs';
import { ReportsFilterTranslationsService } from './services/filters-translations.service';
import { ReportFiltersRepo } from './services/report-filters.repo';

export const provideCoreReportsBreadcrumbsServices = () => [
  AppliedFiltersBreadcrumbsService,
  ReportsBreadcrumbsService,
  DateBreadcrumbsService,
  DatePointsBreadcrumbsService,
  ReportsComponentDetailsBreadcrumbsService,
  DetailsGenericBreadcrumbsService,
  DetailsTrendBreadcrumbsService,
  DetailsFunnelBreadcrumbsService,
];

export const provideCoreReportsLogic = () => [
  ReportsFilterTranslationsService,
  ReportFiltersRepo,
  ReportComponentsVisualizationsFacade,
  ReportsAnalytics,
];
